<div class="container-fluid honoHeaderSection" *ngIf="getAddress(companyData)">
  <div class="row align-items-center py-2">
    <div class="col-md-2 col-lg-2 col-12 pe-0 businessLogoImg">
      <img
        *ngIf="companyData.LogoURL"
        style="width: 140px"
        src="{{ companyData.LogoURL }}"
        class="img-fluid"
        alt="{{ companyData.BusinessTitle }} logo"
        loading="lazy"
      />
    </div>
    <div class="col-md-10 col-lg-10 col-12 businessDetail">
      <h2 class="backColor mb-0 text-truncate">
        {{ companyData.BusinessTitle }}
      </h2>
      <p class="mb-0 mutedText">{{ companyData.Description || '' }}</p>

      <p class="mb-0 font16 mt-2">
        <i class="fa-solid fa-location-dot me-2 primaryColor"></i>
        {{ getAddress(companyData) }}
      </p>

      <p class="mb-3 font16 mt-2">
        <i class="fa-solid fa-phone me-2 primaryColor"></i>
        {{ companyData.MobileCountryCode }} - {{ companyData.MOBILENUMBER }}
      </p>
    </div>
  </div>
</div>
